@if ((type === 'container' || type === 'webform_flexbox') && field) {
  <webform-container
    class="block"
    [attr.data-form-field]="id"
    [attr.data-states-clear]="statesClear"
    [attr.data-form-container]="id"
    [field]="field"
    [parentGroup]="parentGroup"
    [submit]="submit"
    (onSubmit)="submit()"
  ></webform-container>
}

@if (type === 'details' && field) {
  <webform-details
    class="block field-spacing"
    [attr.data-form-field]="id"
    [attr.data-states-clear]="statesClear"
    [attr.data-form-container]="id"
    [field]="field"
    [parentGroup]="parentGroup"
    [submit]="submit"
    (onSubmit)="submit()"
  ></webform-details>
}

<!-- Richt text -->
@if (type === 'processed_text') {
  <mobi-text
    [attr.data-form-field]="id"
    [attr.data-states-clear]="statesClear"
    class="block field-spacing"
    [class]="'webform-field--' + type"
    [data]="field['#text']"
  />
}

@if (type === 'webform_markup') {
  <mobi-text
    [attr.data-form-field]="id"
    [attr.data-states-clear]="statesClear"
    class="block field-spacing pb-[30px] lg:pb-0"
    [class]="'webform-field--' + type"
    [data]="field['#markup']"
  />
}

@if (type === 'mobi_webform_primcalc_calc') {
  <webform-calc
    [attr.data-form-field]="id"
    [attr.data-states-clear]="statesClear"
    class="block pt-[30px] field-spacing"
    [class]="'webform-field--' + type"
    [element]="field"
  ></webform-calc>
}

@if (type === 'mobi_webform_compliance_guidelines') {
  <webform-compliance
    [attr.data-form-field]="id"
    [attr.data-states-clear]="statesClear"
    class="block pt-[30px] field-spacing"
    [class]="'webform-field--' + type"
    [element]="field"
    [parentGroup]="parentGroup"
  ></webform-compliance>
}

@if (type === 'mobi_webform_illustration_section') {
  <webform-illustration-section
    [attr.data-form-field]="id"
    [attr.data-states-clear]="statesClear"
    class="block field-spacing"
    [element]="field"
  />
}

@if (type === 'mobi_webform_primcalc_summary') {
  <webform-summary
    [attr.data-form-field]="id"
    [attr.data-states-clear]="statesClear"
    class="block"
    [class]="'webform-field--' + type"
    [element]="field"
  ></webform-summary>
}

@if (type === 'webform_horizontal_rule') {
  <hr
    [class]="'webform-field--' + type"
    [class.mobi-empty-content]="api.loggedIn()"
    [attr.data-form-field]="id"
    [attr.data-states-clear]="statesClear"
    [style.margin]="field['#spacer'] ? '0' : '15px 0'"
    [style.border-width]="field['#spacer'] ? '0' : '1px'"
    [style.padding-top]="spacerSize"
    [style.padding-bottom]="spacerSize"
    data-empty-content="Webform Horizontal Rule"
  />
}

@if (type === 'webform_link') {
  <webform-link
    class="block field-spacing"
    [attr.data-form-field]="id"
    [attr.data-states-clear]="statesClear"
    [title]="field['#title__title']"
    [url]="field['#url__title']"
  ></webform-link>
}

@if (type === 'mobi_webform_primcalc_gabox') {
  <webform-gabox
    class="block"
    [attr.data-form-field]="id"
    [attr.data-states-clear]="statesClear"
  ></webform-gabox>
}

@if (type === 'mobi_webform_infobox') {
  <webform-infobox
    class="block h-full lg:pt-[30px]"
    [attr.data-form-field]="id"
    [attr.data-states-clear]="statesClear"
    [class]="'webform-field--' + type"
    [title]="title"
    [text]="field['#text']"
    [image]="field['#image'] || null"
    [link]="field['#more_link'] || null"
  ></webform-infobox>
}

@if (type === 'webform_actions') {
  <webform-actions
    [attr.data-form-field]="id"
    [attr.data-states-clear]="statesClear"
    [class]="'webform-field--' + type"
    [actions]="field"
    [group]="parentGroup"
    (onSubmit)="submit()"
  ></webform-actions>
}

@if (type === 'mobi_webform_primcalc_pdfgenerate') {
  <webform-pdfgenerate
    [id]="id"
    [plugin]="field['#plugin']"
    [title]="title"
    [value]="field['#value']"
  ></webform-pdfgenerate>
}

@if (type === 'mobi_webform_primcalc_dsebox') {
  <webform-dsebox [field]="field"></webform-dsebox>
}

@if (type === 'mobi_webform_login_banner') {
  <!-- Login banner: reuse the horizontal form-field layout to align with the input column -->
  <mobi-ui-form-field-major
    class="field-spacing mobi-ui-margin-b-lg block"
    [horizontalLayout]="true"
    [attr.data-form-field]="id"
    [attr.data-states-clear]="statesClear"
  >
    <mobi-form-login-banner></mobi-form-login-banner>
  </mobi-ui-form-field-major>
}

@if (!excludedFields.includes(type)) {
  <ng-container [formGroup]="parentGroup">
    <!-- Description before -->
    @if (field['#description_display'] === 'before' && field['#description']) {
      <ng-template [ngTemplateOutlet]="description"></ng-template>
    }
    <!-- Help before title -->
    @if (field['#help_display'] === 'title_before') {
      <ng-template [ngTemplateOutlet]="help"></ng-template>
    }
    <mobi-ui-form-field-major
      [hidden]="
        disabled ||
        type === 'hidden' ||
        type === 'value' ||
        type === 'tealium_visitor_id' ||
        field['#access'] === false
      "
      [horizontalLayout]="
        (titleDisplay === 'inline' || titleDisplay === null) && !question && !isCard
      "
      class="webform-field"
      [class]="'webform-field--' + type"
      [attr.data-form-field]="id"
      [attr.data-states-clear]="statesClear"
      [attr.data-form-control]="type"
      [class.is-question]="question"
      [class.has-tooltip]="
        field['#description_display'] === 'tooltip' && field['#description']
      "
    >
      @if (
        !question &&
        !isCard &&
        title &&
        type !== 'processed_text' &&
        type !== 'webform_markup' &&
        type !== 'mobi_webform_compliance_guidelines' &&
        titleDisplay !== 'none'
      ) {
        <mobi-ui-label-major [class]="titleDisplay === 'invisible' ? 'sr-only' : ''">
          {{ title }}
        </mobi-ui-label-major>
      }
      <!-- Help before element and after title -->
      @if (
        field['#help_display'] === 'element_before' ||
        field['#help_display'] === 'title_after'
      ) {
        <ng-template [ngTemplateOutlet]="help"></ng-template>
      }
      <div [class.is-sum]="isSum">
        @if (field['#field_prefix']) {
          <span>{{ field['#field_prefix'] }}</span>
        }
        @switch (type) {
          @case ('range') {
            <webform-range
              [formControlName]="id"
              [isRating]="field['#is_rating'] || false"
              [valuePosition]="field['#output'] || 'below'"
              [min]="field['#min'] || 0"
              [max]="field['#max'] || 100"
              [step]="field['#step'] || 1"
            />
          }
          <!-- mobi ziploc component -->
          @case ('mobi_ziploc') {
            <mobi-ui-typeahead-major
              #typeahead
              [formControlName]="id"
              [id]="id | replace: field['#webform'] + '--' : ''"
              [aria-label]="title"
              [placeholder]="placeholder"
              [maxNumberOfOptions]="100"
            >
              @for (ziploc of ga.autocompleteList(); track ziploc) {
                <mobi-ui-typeahead-option-major [value]="ziploc">
                  {{ ziploc }}
                </mobi-ui-typeahead-option-major>
              }
            </mobi-ui-typeahead-major>
          }
          @case ('radios') {
            @if (question) {
              <webform-box
                icon="message_question"
                [iconRed]="true"
                [content]="boxContent"
                [buttons]="boxButtons"
              >
                <ng-template #boxContent>
                  {{ title }}
                </ng-template>
                <ng-template #boxButtons>
                  @for (item of options; track $index) {
                    <input
                      [formControlName]="id"
                      [value]="item.key"
                      type="radio"
                      class="question-radios-input mobi-ui-visually-hidden"
                      tabindex="0"
                      [id]="id + item.key"
                    />
                    <label class="question-radios-label" [for]="id + item.key">
                      {{ getText(item.value) }}
                    </label>
                  }
                </ng-template>
              </webform-box>
            }
            @if (isCard) {
              <mobi-ui-radio-button-group-major
                [formControlName]="id"
                [id]="id | replace: field['#webform'] + '--' : ''"
              >
                <div
                  class="mobi-ui-grid is-align-stretch is-centered mobi-ui-margin-y-md"
                >
                  @for (item of options; track $index) {
                    <button
                      (click)="clickCardRadio($event, item.key)"
                      class="sm:mobi-ui-col-1/3"
                    >
                      <div class="mobi-ui-card-image-major is-clickable h-full">
                        @if (getOptionImage(item.key)) {
                          <div
                            class="!h-auto mobi-ui-card-image-wrapper-major hidden lg:block"
                          >
                            <img
                              class="!w-[35%] !h-auto mx-auto mobi-ui-margin-t-md"
                              [src]="getOptionImage(item.key)"
                              [alt]="getText(item.value)"
                            />
                          </div>
                        }
                        <div
                          class="mobi-ui-card-image-content-major"
                          [class.h-full]="!getOptionImage(item.key)"
                          [class.flex]="!getOptionImage(item.key)"
                          [class.flex-col]="!getOptionImage(item.key)"
                        >
                          <div
                            class="mobi-ui-text-block-major"
                            [class.flex-1]="!getOptionImage(item.key)"
                          >
                            <div
                              class="mobi-ui-text-block-content-major mobi-ui-text-center"
                              [class.!flex]="!getOptionImage(item.key)"
                              [class.flex-col]="!getOptionImage(item.key)"
                              [class.justify-center]="!getOptionImage(item.key)"
                              [class.items-center]="!getOptionImage(item.key)"
                            >
                              <span class="mobi-ui-text-inked mobi-ui-font-h5">
                                {{ getText(item.value) }}
                              </span>
                              <p>
                                {{ getDescription(item.value) }}
                              </p>
                            </div>
                          </div>
                          <mobi-ui-radio-button-major
                            [layoutType]="MobiUiRadioButtonLayoutType.BUTTON_ONLY"
                            [value]="item.key"
                            [attr.data-id]="item.key"
                            (click)="clickCardRadio($event, item.key)"
                          >
                          </mobi-ui-radio-button-major>
                        </div>
                      </div>
                    </button>
                  }
                </div>
              </mobi-ui-radio-button-group-major>
            }
            <!-- Radios. Availble layouts (default: inline): switch|icon|inline -->
            @if (!question && !isCard) {
              @if (
                [
                  'side_by_side',
                  'two_columns',
                  'three_columns',
                  'buttons_horizontal',
                ].includes(field['#options_display'])
              ) {
                <mobi-ui-split-button-group-major
                  [formControlName]="id"
                  [id]="id | replace: field['#webform'] + '--' : ''"
                  [aria-label]="title"
                  [class.radios-submittable]="submittable"
                  [value]="field['#default_value'] || options[0]?.key"
                >
                  @for (item of options; track $index) {
                    <mobi-ui-split-button-major
                      [value]="item.key"
                      [tabindex]="0"
                      class="noclick"
                    >
                      @if (getOptionIcon(item.value)) {
                        <mobi-ui-icon-major [name]="getOptionIcon(item.key) || null" />
                      }
                      {{ getText(item.value) }}
                    </mobi-ui-split-button-major>
                  }
                </mobi-ui-split-button-group-major>
              } @else {
                <mobi-ui-radio-button-group-major
                  [formControlName]="id"
                  [id]="id | replace: field['#webform'] + '--' : ''"
                  [aria-label]="title"
                  [class.radios-submittable]="submittable"
                >
                  @for (item of options; track $index) {
                    <mobi-ui-radio-button-major [value]="item.key">
                      <div class="flex items-center">
                        @if (getOptionIcon(item.key)) {
                          <mobi-ui-icon-major
                            [name]="getOptionIcon(item.key)"
                            class="!pr-[0.9375rem]"
                          />
                        }
                        {{ getText(item.value) }}
                      </div>
                    </mobi-ui-radio-button-major>
                  }
                </mobi-ui-radio-button-group-major>
              }
            }
          }
          <!-- datepicker -->
          @case ('date') {
            @if (question) {
              <webform-box
                [iconRed]="true"
                icon="message_question"
                [content]="datepickerBoxContent"
              >
                <ng-template #datepickerBoxContent>
                  <span class="mb-[15px] block">{{ title }}</span>
                  <ng-template [ngTemplateOutlet]="datepickerRef" />
                </ng-template>
              </webform-box>
            }
            @if (!question) {
              <ng-template [ngTemplateOutlet]="datepickerRef" />
            }
            <ng-template #datepickerRef>
              @if (!field['#inline']) {
                @if (maxDate) {
                  <mobi-ui-datepicker-major
                    #datepicker
                    [formControlName]="id"
                    [id]="id | replace: field['#webform'] + '--' : ''"
                    [aria-label]="title"
                    [defaultDate]="field['#initial_date'] ? getInitialMinDate() : maxDate"
                    [minDate]="minDate"
                    [maxDate]="maxDate"
                    [disableDates]="disableDatesFn"
                  ></mobi-ui-datepicker-major>
                }
                @if (!maxDate) {
                  <mobi-ui-datepicker-major
                    #datepicker
                    [formControlName]="id"
                    [id]="id | replace: field['#webform'] + '--' : ''"
                    [aria-label]="title"
                    [minDate]="minDate"
                    [maxDate]="maxDate"
                    [disableDates]="disableDatesFn"
                  ></mobi-ui-datepicker-major>
                }
              }
              @if (field['#inline']) {
                <input [formControlName]="id" type="text" tabindex="-1" class="hidden" />
                <mobi-ui-calendar-major
                  [aria-label]="title"
                  [date]="inlineDate"
                  [minDate]="minDate"
                  [maxDate]="maxDate"
                  [disableDates]="disableDatesFn"
                  (dateChange)="handleCalendarChange($event)"
                ></mobi-ui-calendar-major>
              }
            </ng-template>
          }
          <!-- Select -->
          @case ('select') {
            @if (question) {
              <webform-box
                [iconRed]="true"
                icon="message_question"
                [content]="selectBoxContent"
              >
                <ng-template #selectBoxContent>
                  <span class="mb-[15px] block">{{ title }}</span>
                  <ng-template [ngTemplateOutlet]="selectRef" />
                </ng-template>
              </webform-box>
            }
            @if (!question) {
              <ng-template [ngTemplateOutlet]="selectRef" />
            }
            <ng-template #selectRef>
              <mobi-ui-dropdown-major
                [formControlName]="id"
                [id]="id | replace: field['#webform'] + '--' : ''"
                [aria-label]="title"
                [disabled]="readonly"
                [emptyOptionLabel]="
                  field['#empty_option'] ||
                  ('select_empty' | texts: { context: 'primcalc', default: 'Auswählen' })
                "
              >
                @for (item of options; track $index) {
                  <mobi-ui-dropdown-option-major [value]="item.key">
                    {{ item.value }}
                  </mobi-ui-dropdown-option-major>
                }
              </mobi-ui-dropdown-major>
            </ng-template>
          }
          <!-- checkbox -->
          @case ('checkbox') {
            <mobi-ui-checkbox-group-major
              [aria-label]="title"
              [formControlName]="id"
              [id]="id | replace: field['#webform'] + '--' : ''"
            >
              <mobi-ui-checkbox-major [name]="id">
                <div class="flex items-center">
                  @if (field['#icon']) {
                    <mobi-ui-icon-major [name]="field['#icon']" class="!pr-[0.9375rem]" />
                  }
                  <div class="mobi-ui-text-break">{{ title }}</div>
                </div>
              </mobi-ui-checkbox-major>
            </mobi-ui-checkbox-group-major>
          }
          <!-- Checkboxes -->
          @case ('checkboxes') {
            @if (isCard) {
              <mobi-ui-checkbox-group-major
                [aria-label]="title"
                [formControlName]="id"
                [id]="id | replace: field['#webform'] + '--' : ''"
              >
                <div
                  class="mobi-ui-grid is-align-stretch is-centered mobi-ui-margin-y-md"
                >
                  @for (item of options; track $index) {
                    <button
                      (click)="clickCardCheckbox($event, item.key)"
                      class="sm:mobi-ui-col-1/3"
                    >
                      <div class="mobi-ui-card-image-major is-clickable h-full">
                        @if (getOptionImage(item.key)) {
                          <div
                            class="!h-auto mobi-ui-card-image-wrapper-major hidden lg:block"
                          >
                            <img
                              class="!w-[35%] !h-auto mx-auto mobi-ui-margin-t-md"
                              [src]="getOptionImage(item.key)"
                              [alt]="getText(item.value)"
                            />
                          </div>
                        }
                        <div
                          class="mobi-ui-card-image-content-major"
                          [class.h-full]="!getOptionImage(item.key)"
                          [class.flex]="!getOptionImage(item.key)"
                          [class.flex-col]="!getOptionImage(item.key)"
                        >
                          <div
                            class="mobi-ui-text-block-major"
                            [class.flex-1]="!getOptionImage(item.key)"
                          >
                            <div
                              class="mobi-ui-text-block-content-major mobi-ui-text-center"
                              [class.!flex]="!getOptionImage(item.key)"
                              [class.flex-col]="!getOptionImage(item.key)"
                              [class.justify-center]="!getOptionImage(item.key)"
                              [class.items-center]="!getOptionImage(item.key)"
                            >
                              <h5 class="mobi-ui-text-inked">
                                {{ getText(item.value) }}
                              </h5>
                              <p>
                                {{ getDescription(item.value) }}
                              </p>
                            </div>
                          </div>
                          <mobi-ui-checkbox-major
                            [name]="'' + item.key"
                            [layoutType]="MobiUiCheckboxLayoutType.CHECKBOX_ONLY"
                            [attr.data-id]="item.key"
                          >
                          </mobi-ui-checkbox-major>
                        </div>
                      </div>
                    </button>
                  }
                </div>
              </mobi-ui-checkbox-group-major>
            } @else {
              <mobi-ui-checkbox-group-major
                [aria-label]="title"
                [formControlName]="id"
                [id]="id | replace: field['#webform'] + '--' : ''"
              >
                @for (item of options; track $index) {
                  <mobi-ui-checkbox-major
                    [name]="'' + item.key"
                    [multiline]="true"
                    [hidden]="item.key === 'hidden' && item.value === 'hidden'"
                    [attr.disabled]="disabledOptions.includes(item.key)"
                    [attr.aria-hidden]="item.key === 'hidden' && item.value === 'hidden'"
                    [attr.data-name]="field['#webform_key'] + '--' + item.key"
                    [class.pointer-events-none]="disabledOptions.includes(item.key)"
                  >
                    <div class="flex items-center">
                      @if (getOptionIcon(item.key)) {
                        <mobi-ui-icon-major
                          [name]="getOptionIcon(item.key)"
                          class="!pr-[0.9375rem]"
                        />
                      }
                      {{ getText(item.value) }}
                    </div>
                  </mobi-ui-checkbox-major>
                }
              </mobi-ui-checkbox-group-major>
            }
          }
          @case ('webform_address') {
            <mobi-address
              [parentForm]="parentGroup"
              [formControlName]="id"
              [id]="id | replace: field['#webform'] + '--' : ''"
              [field]="field"
            ></mobi-address>
          }
          <!-- Phone -->
          @case ('tel') {
            <mobi-ui-phone-input-major
              [aria-label]="title"
              [formControlName]="id"
              [id]="id | replace: field['#webform'] + '--' : ''"
              [readOnly]="readonly"
            ></mobi-ui-phone-input-major>
          }
          <!-- Textarea -->
          @case ('textarea') {
            <mobi-ui-textarea-major
              [aria-label]="title"
              [formControlName]="id"
              [id]="id | replace: field['#webform'] + '--' : ''"
              [placeholder]="placeholder"
              [readOnly]="readonly"
              [value]="field['#default'] || ''"
            ></mobi-ui-textarea-major>
          }
          <!-- Email -->
          @case ('email') {
            <mobi-ui-input-major
              [aria-label]="title"
              [formControlName]="id"
              [id]="id | replace: field['#webform'] + '--' : ''"
              [placeholder]="placeholder"
              [readOnly]="readonly"
            ></mobi-ui-input-major>
          }
          <!-- Number -->
          @case ('number') {
            <mobi-ui-input-major
              type="number"
              [aria-label]="title"
              [formControlName]="id"
              [id]="id | replace: field['#webform'] + '--' : ''"
              [placeholder]="placeholder"
              [readOnly]="readonly"
              [min]="field['#min']"
              [max]="field['#max']"
              [step]="field['#step']"
            ></mobi-ui-input-major>
          }
          <!-- Textfield -->
          @case ('textfield') {
            @if (question) {
              <webform-box
                [iconRed]="true"
                icon="message_question"
                [content]="textfieldBoxContent"
              >
                <ng-template #textfieldBoxContent>
                  <span class="mb-[15px] block">{{ title }}</span>
                  <mobi-ui-input-major
                    class="mt-20px"
                    [aria-label]="title"
                    [formControlName]="id"
                    [id]="id | replace: field['#webform'] + '--' : ''"
                    [placeholder]="placeholder"
                    [readOnly]="readonly"
                  ></mobi-ui-input-major>
                </ng-template>
              </webform-box>
            }
            @if (!question) {
              <!-- Input -->
              @if (!isSum) {
                <mobi-ui-input-major
                  [aria-label]="title"
                  [formControlName]="id"
                  [id]="id | replace: field['#webform'] + '--' : ''"
                  [placeholder]="placeholder"
                  [readOnly]="readonly"
                ></mobi-ui-input-major>
              }
              @if (isSum) {
                <input
                  type="text"
                  [attr.aria-label]="title"
                  [formControlName]="id"
                  class="sum-input"
                  readonly
                />
              }
            }
          }
          <!-- Visitor id for tealium -->
          @case ('managed_file') {
            <mobi-ui-file-input-major
              [aria-label]="title"
              [formControlName]="id"
              [mode]="field['#multiple'] ? 'multiple' : 'single'"
              [id]="id | replace: field['#webform'] + '--' : ''"
              [forceSmallFileSelector]="true"
              [fileSelectorActionLabel]="
                field['#multiple']
                  ? ('upload_files'
                    | texts: { context: 'frontend', default: 'Dateien hinzufügen' })
                  : ('upload_file'
                    | texts: { context: 'frontend', default: 'Datei hinzufügen' })
              "
              [fileSelectorDescriptionLabel]="
                (field['#file_placeholder'] | stripHtml: [] : true) ||
                field['#file_extensions'] ||
                ' '
              "
              [supportedFileTypesHint]="field['#allowed_files']"
              (valueChanges)="handleFileValueChanges($event)"
            />
          }
          <!-- Value field -->
          @case ('value') {
            <input
              class="hidden"
              [formControlName]="id"
              type="text"
              [attr.disabled]="'true'"
            />
          }
          <!-- Value field -->
          @case ('hidden') {
            <input
              class="hidden"
              [formControlName]="id"
              type="text"
              [attr.disabled]="'true'"
            />
          }
          <!-- Visitor id for tealium -->
          @case ('tealium_visitor_id') {
            <input [formControlName]="id" [attr.disabled]="'true'" type="text" />
          }
          <!-- Default for non implemented elements -->
          @default {
            <mobi-ui-input-major
              class="webform-element-support-missing"
              [placeholder]="type + ' is not currently supported'"
              [aria-label]="title"
              [formControlName]="id"
              [readOnly]="true"
            ></mobi-ui-input-major>
          }
        }
        @if (field['#field_suffix']) {
          <span>{{ field['#field_prefix'] }}</span>
        }
      </div>
      <!-- Description after and tooltip -->
      @if (field['#description_display'] === 'tooltip' && field['#description']) {
        <mobi-ui-form-message-major class="tooltip" *mobiUiInfoMessage>
          <ng-template [ngTemplateOutlet]="description" />
        </mobi-ui-form-message-major>
      }
      @if (
        (field['#description_display'] === 'after' ||
          field['#description_display'] === null) &&
        field['#description']
      ) {
        <ng-template [ngTemplateOutlet]="description"></ng-template>
      }
      <!-- Help after and default -->
      @if (
        field['#help_display'] === 'element_after' || field['#help_display'] === null
      ) {
        <ng-template [ngTemplateOutlet]="help"></ng-template>
      }
      <!-- more accordion -->
      @if (field['#more_title'] || field['#more']) {
        <ng-template [ngTemplateOutlet]="more"></ng-template>
      }
      <!-- Error messages -->
      <mobi-ui-form-message-major *mobiUiErrorMessage="'required'">
        {{
          field['#required_error'] ||
            errorReplace(
              'required'
                | texts
                  : {
                      context: 'errors',
                      default: '{name} ist erforderlich',
                    }
            )
        }}
      </mobi-ui-form-message-major>
      <mobi-ui-form-message-major *mobiUiErrorMessage="'pattern'">
        {{
          field['#pattern_error'] ||
            errorReplace(
              'pattern'
                | texts
                  : {
                      context: 'errors',
                      default: '{name} muss mit {pattern} übereinstimmen',
                    }
            )
        }}
      </mobi-ui-form-message-major>
      @if (
        type === 'select' ||
        type === 'radios' ||
        type === 'checkboxes' ||
        type === 'mobi_ziploc'
      ) {
        <mobi-ui-form-message-major *mobiUiErrorMessage="'atLeastOneSelected'">
          {{
            field['#required_error'] ||
              errorReplace(
                'required'
                  | texts
                    : {
                        context: 'errors',
                        default: '{name} ist erforderlich',
                      }
              )
          }}
        </mobi-ui-form-message-major>
      }
      @if (type === 'textarea' || type === 'textfield') {
        <mobi-ui-form-message-major *mobiUiErrorMessage="'minlength'">
          {{
            errorReplace(
              'minlength'
                | texts
                  : {
                      context: 'errors',
                      default: '{name} muss mindesten {minVal} Zeichen haben',
                    }
            )
          }}
        </mobi-ui-form-message-major>
      }
      @if (type === 'textarea' || type === 'textfield') {
        <mobi-ui-form-message-major *mobiUiErrorMessage="'maxlength'">
          {{
            errorReplace(
              'maxlength'
                | texts
                  : {
                      context: 'errors',
                      default: '{name} darf maximal {maxVal} Zeichen haben',
                    }
            )
          }}
        </mobi-ui-form-message-major>
      }
      @if (
        type === 'textarea' ||
        type === 'textfield' ||
        type === 'email' ||
        type === 'tel' ||
        type === 'number'
      ) {
        <mobi-ui-form-message-major *mobiUiErrorMessage="'xssContent'">
          {{
            errorReplace(
              'xssContent'
                | texts
                  : {
                      context: 'errors',
                      default: '{name} enthält unzulässige HTML- oder Skript-Inhalte',
                    }
            )
          }}
        </mobi-ui-form-message-major>
      }
      @if (type === 'number') {
        <mobi-ui-form-message-major *mobiUiErrorMessage="'min'">
          {{
            errorReplace(
              'min'
                | texts
                  : {
                      context: 'errors',
                      default: '{name} muss mindesten {minVal} sein',
                    }
            )
          }}
        </mobi-ui-form-message-major>
      }
      @if (type === 'number') {
        <mobi-ui-form-message-major *mobiUiErrorMessage="'max'">
          {{
            errorReplace(
              'max'
                | texts
                  : {
                      context: 'errors',
                      default: '{name} darf maximal {maxVal} sein',
                    }
            )
          }}
        </mobi-ui-form-message-major>
      }
      @if (type === 'number') {
        <mobi-ui-form-message-major *mobiUiErrorMessage="'step'">
          {{
            errorReplace(
              'step'
                | texts
                  : {
                      context: 'errors',
                      default: '{name} muss ein Vielfaches von {stepVal} sein',
                    }
            )
          }}
        </mobi-ui-form-message-major>
      }
      @if (type === 'email') {
        <mobi-ui-form-message-major *mobiUiErrorMessage="'email'">
          {{
            errorReplace(
              'email'
                | texts
                  : {
                      context: 'errors',
                      default: 'Bitte geben Sie eine gültige E-Mail Adresse ein',
                    }
            )
          }}
        </mobi-ui-form-message-major>
      }
      @if (type === 'tel') {
        <mobi-ui-form-message-major *mobiUiErrorMessage="'validPhoneNumber'">
          {{
            errorReplace(
              'tel'
                | texts
                  : {
                      context: 'errors',
                      default:
                        'Bitte geben Sie eine gültige Telefonnummer mit der Vorwahl ein (+41)',
                    }
            )
          }}
        </mobi-ui-form-message-major>
      }
      @if (type === 'date') {
        <mobi-ui-form-message-major *mobiUiErrorMessage="'minDate'">
          @if (minDateError) {
            <span>
              {{ minDateError }}
            </span>
          } @else {
            {{
              errorReplace(
                'datemin'
                  | texts
                    : {
                        context: 'errors',
                        default: '{name} darf nicht vor {minVal} liegen',
                      }
              )
            }}
          }
        </mobi-ui-form-message-major>
      }
      @if (type === 'date') {
        <mobi-ui-form-message-major *mobiUiErrorMessage="'maxDate'">
          @if (maxDateError) {
            <span>
              {{ maxDateError }}
            </span>
          } @else {
            {{
              errorReplace(
                'datemax'
                  | texts
                    : {
                        context: 'errors',
                        default: '{name} darf nicht nach {maxVal} liegen',
                      }
              )
            }}
          }
        </mobi-ui-form-message-major>
      }
      @if (type === 'managed_file') {
        <mobi-ui-form-message-major *mobiUiErrorMessage="'maxFileSize'">
          {{
            errorReplace(
              'max_file_size'
                | texts
                  : {
                      context: 'errors',
                      default: 'Eine Datei darf nicht größer als {maxSize} sein',
                    }
            )
          }}
        </mobi-ui-form-message-major>
        <mobi-ui-form-message-major *mobiUiErrorMessage="'maxFilesCount'">
          {{
            errorReplace(
              'max_file_count'
                | texts
                  : {
                      context: 'errors',
                      default: 'Es dürfen maximal {maxCount} Dateien hochgeladen werden',
                    }
            )
          }}
        </mobi-ui-form-message-major>
        <mobi-ui-form-message-major *mobiUiErrorMessage="'allowedFileTypes'" class="mb-2">
          {{
            errorReplace(
              'file_type'
                | texts
                  : {
                      context: 'errors',
                      default:
                        'Es sind nur folgende Dateiformate erlaubt: {allowedTypes}',
                    }
            )
          }}
        </mobi-ui-form-message-major>
      }
    </mobi-ui-form-field-major>
  </ng-container>
}

<ng-template #description>
  @if (field['#description']) {
    <div class="description">
      @if (field && field['#description']) {
        <mobi-text [data]="field['#description']" />
      }
    </div>
  }
</ng-template>

<ng-template #help>
  @if (field['#help_title'] || field['#help']) {
    <div class="help">
      @if (field['#help_title']) {
        <span class="mobi-ui-font-tisa mobi-ui-font-medium">
          {{ field['#help_title'] }}
        </span>
      }
      @if (field['#help']) {
        <mobi-text [data]="field['#help']" />
      }
    </div>
  }
</ng-template>

<ng-template #more>
  <mobi-ui-expander-major
    class="more"
    [title]="
      field['#more_title'] || ('more' | texts: { context: 'frontend', default: 'Mehr' })
    "
    [content]="expanderContent"
  >
    <ng-template #expanderContent>
      <mobi-text [data]="field['#more']" />
    </ng-template>
  </mobi-ui-expander-major>
</ng-template>
